import { useState } from "react";
import { validateLocation } from "../utils";
import axios from "axios";

import CONFIG from '../config.json';
import { useCookies } from "react-cookie";
import { Locations, Location } from "../ui";
import { Label } from "../components/Label";
import { ErrorMessage } from "../components/ErrorMessage";

export const useCheckLogic = () => {

    const [locationField, setLocationField] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [data, setData] = useState<{ location: string, eans: string[] }>();

    const [cookie, setCookie, removeCookie] = useCookies(['access_key']);

    const checkPalleteLocation = () => {
        if (!validateField()) {
            setData(undefined);
            return;
        }
        setErrorMessage('');
        axios.get(CONFIG.API, {
            params: {
                location: locationField,
                accessKey: cookie.access_key
            }
        }).then((res) => {
            setData({
                eans: res.data.eans,
                location: res.data.location
            });
        }).catch((err) => {
            if (!err.response) {
                setErrorMessage('Server error, try again');
                return;
            }
            setErrorMessage(err.response.data.message);
            setData(undefined);
        });
    }

    const validateField = () => {
        if (!validateLocation(locationField)) {
            setErrorMessage('Podaj lokalizację w formacie REGEX: [DJ]-[0-9]{2}-[0-9]{2}-[1-3]/[1-3]');
            return false;
        }
        return true;
    }

    const showData = () => {
        if (!data) return;
        if (data.eans.length === 0) return (
            <>
                <ErrorMessage>Brak EAN-ów na tej palecie</ErrorMessage>
            </>
        )
        return (
            <>
                <Label>{data.location}</Label>
                <Locations>{data.eans.map((ean, index) => <Location key={index}>{ean}</Location>)}</Locations>
            </>
        )
    }

    return { setLocationField, errorMessage, data, checkPalleteLocation, showData }
}